import {
    GESTION_OPERATIVA_UPDATE_BILLS_BEGIN,
    GESTION_OPERATIVA_UPDATE_BILLS_DISMISS_ERROR
} from '../constants';


export function updateFactura( id, body ) {
    return (dispatch) => {
        dispatch({
            type: GESTION_OPERATIVA_UPDATE_BILLS_BEGIN,
            data: {id, body}
        })
    }
}

export function dismissAddFacturaError() {
    return {
      type: GESTION_OPERATIVA_UPDATE_BILLS_DISMISS_ERROR
    }
}
